/**
 * Estilos para CheckoutStepper component
 * Adaptado de car-ecommerce-app con 3 estados: active, previous, normal
 *
 * ✅ 100% del theme centralizado: carrefour-ui + customizaciones
 * ❌ Cero hardcodes de colores, tamaños, etc.
 */

import { CSSProperties } from 'react';
import { theme } from '../../theme';

const STEP_SIZE = 24; // Diámetro del círculo del paso (muy pequeño)
const CONNECTOR_HEIGHT = 2; // Alto de la línea conectora

export const stepperStyles = {
  stepperContainer: {
    position: 'relative',
    padding: `${theme.spacing.small}px 0`,
  } as CSSProperties,

  stepper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 0,
    position: 'relative',
    width: '100%',
  } as CSSProperties,

  stepperLine: {
    position: 'absolute',
    top: 36,
    left: 0,
    right: 0,
    height: CONNECTOR_HEIGHT,
    backgroundColor: theme.colors.button.primary,
    zIndex: 0,
  } as CSSProperties,

  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    position: 'relative',
    zIndex: 1,
    flex: 1,
  } as CSSProperties,

  alignLeft: {
    alignItems: 'flex-start',
  } as CSSProperties,

  alignRight: {
    alignItems: 'flex-end',
  } as CSSProperties,

  step: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    position: 'relative',
        backgroundColor: theme.colors.white,

  } as CSSProperties,

  stepNumberContainer: {
    width: STEP_SIZE,
    height: STEP_SIZE,
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '6px',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: '10px',
    transition: `all ${theme.transitions.fast}`,
    backgroundColor: theme.colors.palette.blue200,
    color: 'white',
    border: 'none',
  } as CSSProperties,

  stepNumberContainerActive: {
    backgroundColor: theme.colors.palette.blue100,
    color: 'white',
    border: 'none',
  } as CSSProperties,

  stepNumberContainerPrevious: {
    backgroundColor: theme.colors.palette.blue200,
    color: 'white',
    border: 'none',
  } as CSSProperties,

  stepNumber: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: '14px',
    lineHeight: '1',
  } as CSSProperties,

  stepLabel: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    lineHeight: '1.2',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    color: theme.colors.palette.blue200,
    fontWeight: theme.typography.fontWeight.normal,
  } as CSSProperties,

  stepLabelActive: {
    color: theme.colors.palette.blue100,
    fontWeight: theme.typography.fontWeight.normal,
  } as CSSProperties,

  stepLabelPrevious: {
    color: theme.colors.palette.blue200,
    fontWeight: theme.typography.fontWeight.normal,
  } as CSSProperties,
} as const;
